<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<ng-container [formGroup]='form'>

  <div *ngIf='!hide'>
    <div class='row my'>
      <div class='p-field pb col-12'>
        <p-floatlabel variant="on">
          <input id='addressLine' pInputText type='text' wellInputTrim formControlName='addressLine'
                 [ngStyle]="{'width': '100%'}" data-testid="address-line-input">
          <label for='addressLine'>{{ 'address.addressLine' | translate }}:</label>
        </p-floatlabel>
      </div>

      <div class='p-field pb col-6' *ngIf='!showSectorDropdown'>
        <p-floatlabel variant="on">
          <input id='city' pInputText type='text' formControlName='city' formInlineError='address.error'
                 wellInputTrim
                 [ngStyle]="{'width': '100%'}" data-testid="city-input">
          <label for='city'>{{ 'address.city' | translate }}: (*)</label>
        </p-floatlabel>
      </div>

      <div class='p-field pb col-6' *ngIf='showSectorDropdown'>
        <p-floatlabel variant="on">
          <well-sector-dropdown id='sector' formControlName='city' formInlineError='address.error' data-testid="city-dropdown"/>
          <label for='sector'>{{ 'address.city' | translate }}: (*)</label>
        </p-floatlabel>
      </div>

      <div class='p-field pb col-6'>
        <p-floatlabel variant="on">
          <input id='postalCode' pInputText type='text' formControlName='postalCode' formInlineError='address.error'
                 wellInputTrim
                 class='full-width' data-testid="postal-code-input">
          <label for='postalCode'>{{ translationSchema.address.postalCode | translate }}: <span
            *ngIf='postalCodeFormControl.validator'>(*)</span></label>
        </p-floatlabel>
      </div>

      <div class='p-field pb col-6'>
        <p-floatlabel variant="on">
          <input id='streetName' pInputText type='text' formControlName='streetName' formInlineError='address.error'
                 wellInputTrim
                 [ngStyle]="{'width': '100%'}" data-testid="street-name-input">
          <label for='streetName'>{{ 'address.streetName' | translate }}:
            <span *ngIf='(!handoverAddress && companyRequired) || showStreetRequiredStar'>(*)</span>
          </label>
        </p-floatlabel>
      </div>

      <div class='p-field pb col-6'>
        <p-floatlabel variant="on">
          <input id='streetNumber' pInputText type='text' formControlName='streetNumber' formInlineError='address.error'
                 wellInputTrim
                 [ngStyle]="{'width': '100%'}" data-testid="street-number-input">
          <label for='streetNumber'>{{ 'address.streetNumber' | translate }}:
            <span *ngIf='(!handoverAddress && companyRequired) || showStreetRequiredStar'>(*)</span>
          </label>
        </p-floatlabel>
      </div>

      @if (displayAdditionalFields) {
        <div class='p-field pb col-3'>
          <p-floatlabel variant="on">
            <input id='block' pInputText type='text' formControlName='block' wellInputTrim
                   [ngStyle]="{'width': '100%'}" data-testid="block-input">
            <label for='block'>{{ 'address.block' | translate }}:</label>
          </p-floatlabel>
        </div>

        <div class='p-field pb col-3'>
          <p-floatlabel variant="on">
            <input id='building' pInputText type='text' formControlName='building' wellInputTrim
                   [ngStyle]="{'width': '100%'}" data-testid="building-input">
            <label for='building'>{{ 'address.building' | translate }}:</label>
          </p-floatlabel>
        </div>

        <div class='p-field pb col-3'>
          <p-floatlabel variant="on">
            <input id='floor' pInputText type='text' formControlName='floor' wellInputTrim
                   [ngStyle]="{'width': '100%'}" data-testid="floor-input">
            <label for='floor'>{{ 'address.floor' | translate }}:</label>
          </p-floatlabel>
        </div>

        <div class='p-field pb col-3'>
          <p-floatlabel variant="on">
            <input id='apartment' pInputText type='text' formControlName='apartment' wellInputTrim
                   [ngStyle]="{'width': '100%'}" data-testid="apartment-input">
            <label for='apartment'>{{ 'address.apartment' | translate }}:</label>
          </p-floatlabel>
        </div>
      }

      <div class='p-field pb col' *ngIf='!showCountyDropdown'>
        <p-floatlabel variant="on">
          <input id='state' pInputText type='text' formControlName='state' wellInputTrim [ngStyle]="{'width': '100%'}" data-testid="state-input">
          <label for='state'>{{ 'address.state' | translate }}:</label>
        </p-floatlabel>
      </div>

      <div class='p-field pb col' *ngIf='showCountyDropdown'>
        <p-floatlabel variant="on">
          <well-county-dropdown id='countyRO' formControlName='state' formInlineError='address.error' data-testid="state-dropdown"/>
          <label for='countyRO'>{{ 'address.state' | translate }}: (*)</label>
        </p-floatlabel>
      </div>

      @if (!eTransportContext) {
        <div class='p-field pb col-6'>
          <p-floatlabel variant="on">
            <well-country-dropdown id='country' formControlName='country' formInlineError='address.error' data-testid="country-dropdown"/>
            <label for='country'>{{ 'address.country' | translate }}:
              @if (!eTransportContext) {
                <span>(*)</span>
              }
            </label>
          </p-floatlabel>
        </div>
      }

      <div class='p-field pb-sm col-12' *ngIf='!handoverAddress'>
        <p-floatlabel variant="on">
          <textarea pTextarea id='details' formControlName='details' [rows]='6'
                    wellInputTrim
                    autoResize='autoResize' [style]="{width: '100%'}" data-testid="details-textarea">
          </textarea>
          <label for='country'>{{ 'address.details' | translate }}:</label>
        </p-floatlabel>
      </div>

    </div>

    <div class='row' *ngIf='displayTypeField'>

      <div class='p-field pb col-6 pr' *ngIf='addressTypeValueControl'>
        <p-floatlabel variant="on">
          <p-select id='addressTypeValue'
                      #dropdown
                      [style]="{'width':'100%'}"
                      [readonly]='mainAddress || !displayTypeField'
                      (onClear)='dropdown.hide()'
                      pTooltip="{{'address.readonlyAddressType' | translate}}"
                      [tooltipDisabled]='!mainAddress'
                      formControlName='addressTypeValue'
                      [autoDisplayFirst]='false'
                      [options]='addressTypes'
                      formInlineError='address.error' data-testid="address-type-value-select">
          </p-select>
          <label for='addressTypeValue'>{{ 'address.type' | translate }}: (*)</label>
        </p-floatlabel>
      </div>

      <div *ngIf='addressTypeValueControl && displayMainAddress' class='p-field pb col-6 align-self-center'>
        <p-toggleswitch id='mainAddress' [disabled]='this.form.disabled' [ngModel]='mainAddress'
                       (ngModelChange)='mainAddressCheckboxChanged($event)'
                       [ngModelOptions]='{standalone: true}' data-testid="main-address-toggle"></p-toggleswitch>

        <label for='mainAddress' class='ml'>{{ 'address.mainAddress' | translate }}</label>
      </div>

    </div>
    <div class='row'>

      <div class='p-field pb col-6 pr' *ngIf='displayVisibilityField'>
        <p-floatlabel variant="on">
          <p-select id='visibilityType' [style]="{'width': '100%'}" formControlName='visibilityType'
                      [autoDisplayFirst]='false'
                      [options]='visibilityTypes'
                      formInlineError='address.error' data-testid="visibility-type-select">
          </p-select>
          <label for='visibilityType'>{{ 'address.visibility' | translate }}: (*)</label>
        </p-floatlabel>
        <span
          *ngIf='visibilityTypeControl.value'>{{ translationSchema.utils.visibilityTypeDescription[visibilityTypeControl.value] | translate }}</span>
      </div>

    </div>

    <div class='row'>

      <div class='pb-sm col-12' *ngIf='shouldAddressBeSaved '>
        <ng-container *ngIf='displayAddressTemplateSave; else:simpleInput'>
          <span [pTooltip]='translationSchema.address["save-disabled"] | translate' [tooltipDisabled]='form.valid'>
            <button pButton type='button' class='p-button-outlined flat full-width'
                    [label]="!eTransportContext ? (translationSchema.address['save-address-label'] | translate) : (translationSchema.utils.saveForLater | translate)"
                    icon='ui-icon-add' (click)='showAddressLabelDialog()'
                    [disabled]='form.disabled || !form.valid' data-testid="e-transport-context-translation-schema-address-btn">
            </button>
          </span>

          <p-dialog appendTo='body' baseZIndex='10000000000' [modal]='true' [closable]='false' [dismissableMask]='false'
                    header="{{'address.save-address-title' | translate}}"
                    [(visible)]='displaySavePopup'>
            <div class='p-field pb col-12 mt-lg'>
              <p-floatlabel variant="on">
                <input id='addressLabel' pInputText type='text' formControlName='addressLabel'
                       formInlineError='address.error'
                       [ngStyle]="{'width': '100%'}" data-testid="address-label-input">
                <label for='addressLabel'>{{ 'address.addressLabel' | translate }} *</label>
              </p-floatlabel>
            </div>

            <ng-template pTemplate="footer">
              <button pButton type='button' class='p-button-text mr' [label]="'address.hideDialog' | translate"
                      (click)='onHideDialog()' data-testid="on-hide-dialog-btn"></button>

              <button pButton type='button' [label]="'address.utils.save' | translate"
                      (click)='onAddressTemplateSave()' data-testid="on-address-template-save-btn"></button>
            </ng-template>

          </p-dialog>
        </ng-container>
        <ng-template #simpleInput>
          <div *ngIf='showAddressLabel'>
            <p-floatlabel variant="on">
              <input id='addressLabelSimpleInput' pInputText type='text' formControlName='addressLabel'
                     wellInputTrim [ngStyle]="{'width': '100%'}" data-testid="address-label-input-2">
              <label for='addressLabel'>{{ 'address.addressLabel' | translate }}</label>
            </p-floatlabel>
          </div>
        </ng-template>
      </div>

    </div>
  </div>
</ng-container>


